import React from 'react';
import IHCLogo from 'dataModule/assets/img/HealthBeats.svg';
import LogoRegistered from 'appModule/auth/assets/img/registered-logo.svg';

export default ({ width = 350, ...props }) => <img src={IHCLogo} width={width} {...props} />;

export const logoAuth = ({ width = 393, ...props }) => <img src={LogoRegistered} width={width} {...props} />;
